import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';

@Component({
  selector: 'app-cooking-story-slider',
  templateUrl: './cooking-story-slider.component.html',
  styleUrls: ['./cooking-story-slider.component.scss'],
})
export class CookingStorySliderComponent implements OnInit {
  recipes;
  ratio: string = '1:1';
  width: number;
  height: number;
  @Input() set posts(posts) {
    this.recipes = posts.recipes;
    this.ratio = posts.ratio || '1:1';
    this.width = this.ratio && this.ratio !== '1:1' ? 320 : 148;
    this.height = this.ratio && this.ratio !== '1:1' ? 180 : 148;
    if (this.ratio == '16:9') {
      this.suggest = true;
    }
    this.activated = new Array(posts.length).fill(false);
    this.activated[0] = true;
    if (!this.suggest) {
      this.activated[1] = true;
    } else {
      this.width = window.innerWidth * 80 * 0.01;
    }
  }
  activated: boolean[];
  @Input() ready: boolean = false;
  @Input() suggest: boolean = false;
  @ViewChild('slider') sllider: ElementRef<HTMLDivElement>;
  constructor(private recipeService: RecipeService) {}
  ngOnInit(): void {}
  scroll(data) {
    for (
      let index: number = 0;
      index < this.sllider.nativeElement.children.length;
      index++
    ) {
      const currentEl = this.sllider.nativeElement
        .getElementsByClassName('post')
        [index].getBoundingClientRect().right;
      let middle;
      if (!this.suggest) {
        middle = window.innerWidth / 2;
      } else {
        // middle = window.innerWidth * 75 * 0.01;
        middle = window.innerWidth / 2;
      }
      if (currentEl >= middle) {
        this.activated[index] = true;
      } else {
        this.activated[0] = true;
        if (!this.suggest) this.activated[1] = true;
        this.activated[index] = false;
      }
    }
  }
  openRecipe(recipeId) {
    this.recipeService.goToRecipeDetail(recipeId);
  }
  garr(length: number) {
    return new Array(length);
  }
}
